import { MouseEvent, useCallback } from 'react';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { FlexCenHorVer } from '@/UI/styles';
import ParentMenuItem from '@/components/Recipe/Menu/ParentMenuItem';
import { AppMenuItem } from '@/UI/AppContextMenu/AppMenu.styles';
import { CheckMarkIcon } from '@/UI/Icons/CheckMarkIcon';
import { I18N_KEYS } from '@/language/keys';
import type { EdgeTypePreference } from '@/types/auth.types';

interface EdgeTypeMenuProps {
  edgeType: EdgeTypePreference;
  onEdgeTypeChange: (value: EdgeTypePreference) => void;
  onClose: () => void;
}

export function EdgeTypeMenu({ edgeType, onEdgeTypeChange, onClose }: EdgeTypeMenuProps) {
  const { t } = useTranslation();

  const handleEdgeTypeSelect = useCallback(
    (value: EdgeTypePreference) => (e: MouseEvent<HTMLElement>) => {
      e.stopPropagation();
      onEdgeTypeChange(value);
    },
    [onEdgeTypeChange],
  );

  return (
    <ParentMenuItem
      id="edge-style"
      label={t(I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_TOOLS_PANEL.MAIN_MENU.EDGE_STYLE)}
      onClose={onClose}
      contextMenuWidth="260px"
      offset={{ left: '10px', top: '-9px' }}
    >
      <AppMenuItem onClick={handleEdgeTypeSelect('bezier')}>
        <FlexCenHorVer sx={{ justifyContent: 'space-between', width: '100%' }}>
          <Typography fontSize="inherit">
            {t(I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_TOOLS_PANEL.MAIN_MENU.EDGE_STYLE_BEZIER)}
          </Typography>
          {edgeType === 'bezier' && <CheckMarkIcon />}
        </FlexCenHorVer>
      </AppMenuItem>
      <AppMenuItem onClick={handleEdgeTypeSelect('step')}>
        <FlexCenHorVer sx={{ justifyContent: 'space-between', width: '100%' }}>
          <Typography fontSize="inherit">
            {t(I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_TOOLS_PANEL.MAIN_MENU.EDGE_STYLE_STEP)}
          </Typography>
          {edgeType === 'step' && <CheckMarkIcon />}
        </FlexCenHorVer>
      </AppMenuItem>
      <AppMenuItem onClick={handleEdgeTypeSelect('line')}>
        <FlexCenHorVer sx={{ justifyContent: 'space-between', width: '100%' }}>
          <Typography fontSize="inherit">
            {t(I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_TOOLS_PANEL.MAIN_MENU.EDGE_STYLE_LINE)}
          </Typography>
          {edgeType === 'line' && <CheckMarkIcon />}
        </FlexCenHorVer>
      </AppMenuItem>
    </ParentMenuItem>
  );
}
